import request from '@/utils/request'
import axios from 'axios'

export const preProductionApi = {
  create(data) {
    return request({
      url: '/inventory-management-api/preproduction/create',
      method: 'POST',
      data
    })
  },

  list(data) {
    return request({
      url: '/inventory-management-api/preproduction/list',
      method: 'POST',
      data
    })
  },

  summary(data) {
    return request({
      url: '/inventory-management-api/preproduction/summary',
      method: 'POST',
      data
    })
  },

  detail(id) {
    return request({
      url: '/inventory-management-api/preproduction/detail',
      method: 'POST',
      data: { id }
    })
  },

  update(data) {
    return request({
      url: '/inventory-management-api/preproduction/update',
      method: 'POST',
      data
    })
  },

  complete(data) {
    return request({
      url: '/inventory-management-api/preproduction/complete',
      method: 'POST',
      data
    })
  },

  updatePaymentStatus(data) {
    return request({
      url: '/inventory-management-api/preproduction/updatePaymentStatus',
      method: 'POST',
      data
    })
  },

  completionList(data) {
    return request({
      url: '/inventory-management-api/preproduction/completionList',
      method: 'POST',
      data
    })
  },

  completionUpdate(data) {
    return request({
      url: '/inventory-management-api/preproduction/completionUpdate',
      method: 'POST',
      data
    })
  },

  completionDelete(data) {
    return request({
      url: '/inventory-management-api/preproduction/completionDelete',
      method: 'POST',
      data
    })
  },

  completionSummary(data) {
    return request({
      url: '/inventory-management-api/preproduction/completionSummary',
      method: 'POST',
      data
    })
  },

  completionExport(data) {
    const sessionId = localStorage.getItem('sessionId') || ''
    const requestData = {
      sessionId: sessionId,
      data: data || {}
    }
    return axios({
      url: '/inventory-management-api/preproduction/completionExport',
      method: 'POST',
      data: requestData,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json'
      },
      baseURL: process.env.NODE_ENV === 'development' ? '' : (process.env.VUE_APP_API_BASE_URL || ''),
      timeout: 60000
    })
  },

  deleteItem(id) {
    return request({
      url: '/inventory-management-api/preproduction/deleteItem',
      method: 'POST',
      data: { id }
    })
  },

  cancel(id) {
    return request({
      url: '/inventory-management-api/preproduction/cancel',
      method: 'POST',
      data: { id }
    })
  },

  delete(id) {
    return request({
      url: '/inventory-management-api/preproduction/delete',
      method: 'POST',
      data: { id }
    })
  },

  export(data) {
    const sessionId = localStorage.getItem('sessionId') || ''
    const requestData = {
      sessionId: sessionId,
      data: data || {}
    }

    return axios({
      url: '/inventory-management-api/preproduction/export',
      method: 'POST',
      data: requestData,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json'
      },
      baseURL: process.env.NODE_ENV === 'development' ? '' : (process.env.VUE_APP_API_BASE_URL || ''),
      timeout: 30000
    })
  }
}
